// extracted by mini-css-extract-plugin
module.exports =  {"info":"_2787e5dfdf--info--JAvte","data":"_2787e5dfdf--data--Nd83q","logo":"_2787e5dfdf--logo--my1AX"};